import { render, staticRenderFns } from "./DesignFormAuthModal.vue?vue&type=template&id=be2a309e&scoped=true&"
import script from "./DesignFormAuthModal.vue?vue&type=script&lang=js&"
export * from "./DesignFormAuthModal.vue?vue&type=script&lang=js&"
import style0 from "./DesignFormAuthModal.vue?vue&type=style&index=0&id=be2a309e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2a309e",
  null
  
)

export default component.exports